import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResetPasswordComponent } from './modules/reset-password/reset-password.component';
import { LoginComponent } from './modules/login/login.component';
import { ForgetPasswordComponent } from './modules/forget-password/forget-password.component';

const routes: Routes = [
  {
    path: '', component: LoginComponent
  },
  {
    path: 'resetPassword', component: ResetPasswordComponent
  },
  {
    path: 'forgetPassword', component: ForgetPasswordComponent
  },
  {
    path: 'admin',
    loadChildren: () => import('../app/modules/admin-portal/admin-portal.module').then((m) => m.AdminPortalModule),
  },
  {
    path: 'publisher',
    loadChildren: () => import('../app/modules/publisher-portal/publisher-portal.module').then((m) => m.PublisherPortalModule),
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
